import HomeIcon from '@mui/icons-material/Home';
import { type Company } from 'src/shared/types/company';
import Select from 'src/shared/components/Form/Select';
import { useTranslation } from 'react-i18next';
import { Step } from '../../../../../components/Step';
import { required } from 'redux-form-validators';
import useStep2 from './hooks';
import { Box } from '@mui/material';
import { type FactorialParamsResponse, type FactorialLegalEntity } from 'src/shared/api/integrations/factorial';

export const mapFactorialLegalEntitiesToSelect = (data: FactorialLegalEntity[]) =>
  data.map(el => ({ label: el.legal_name, value: el.id }));

type Step2Props = {
  data: FactorialParamsResponse | undefined;
};

export const Step2 = ({ data }: Step2Props) => {
  const { t } = useTranslation('settings');
  const { values, companiesToSelect } = useStep2();

  if (!companiesToSelect || !data) {
    return <></>;
  }

  const selectedCompany = companiesToSelect?.find((company: Company) => values.company === company.taxIdentifier);

  return selectedCompany ? (
    <>
      <Step
        title={`${t('integrations.step')} 2`}
        subtitle={`${t('synchronise your legal entities by selecting the corresponding legal entity in Factorial', {
          ns: 'settings'
        })}:`}
        Icon={HomeIcon}
      >
        <Box sx={{ marginBottom: 4 }}>
          <Select
            sx={{ maxWidth: '300px' }}
            label={selectedCompany.name}
            data={mapFactorialLegalEntitiesToSelect(data?.legalEntities) ?? []}
            name={`legalEntityId`}
            fieldProps={{ validate: required() }}
          />
        </Box>
      </Step>
    </>
  ) : (
    <></>
  );
};
